import { Styles, css, extractTransition, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    z-index: 3;
  `,
  content: css`
    min-width: 630px;
    height: 100vh;

    @media (max-height: 827px) {
      min-width: 556px;
      width: 556px;
    }
  `,
  header: css`
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  `,
  headerTitle: css`
    display: flex;
    gap: 8px;
    align-items: center;
  `,
  headerDescription: css``,
  contentBody: css`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 100%;
    min-width: 628px;
    transform-origin: top left;

    @media (max-height: 827px) {
      transform: scale(0.8);
    }
  `,
  emailPill: ({ theme }) => css`
    display: inline-flex;
    padding: 6px 12px;
    background-color: ${theme.colors.neutral.variant[10]};
    align-self: flex-start;
    border-radius: 12px;
    cursor: default;

    ${extractTransition((f) => f.cubic, { property: 'background-color', duration: 220 })}

    &:hover {
      background-color: ${theme.colors.neutral.variant[20]};
    }
  `,
  outreachEditorSkeleton: css`
    display: flex;
    flex: 1 1 100%;
  `,
  nylasCalendarContainer: css`
    width: 628px;
  `,
  nylasCalendar: css`
    box-shadow: unset;
    transform: scale(0.8);
    transform-origin: top left;
  `,
  errorContainer: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    height: 100%;
    border-radius: 24px;
    border-width: 2px;
    border-style: dashed;
    border-color: ${theme.colors.neutral.variant[30]};
  `,
  saveButtonContainer: css`
    display: flex;
    justify-content: flex-end;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
